import React, { memo, useState } from "react";
import Spinner from "../../Spinner";
import ManualAudioResultRow from "../rows/ManualAudioResultRow";
import { useMeasurementResults } from "../../../hooks/results/useMeasurementResults";
import {
  DEFAULT_RESULTS_PAGE_SIZE,
  useInfiniteResultsPageSize,
} from "../../../hooks/results/useInfiniteResultsPageSize";
import { useResultRowNavigation } from "../../../hooks/results/useResultRowNavigation";
import { RESULT_MODE_CONFIG } from "../../../utils/results/resultModeConfig";
import ResultsTabState from "../ResultsTabState";

const CONFIG = RESULT_MODE_CONFIG.manualAudio;

export default memo(function ManualAudioResults({
  db,
  uid,
  firstRunByVariant,
}) {
  const [pageSize, setPageSize] = useState(DEFAULT_RESULTS_PAGE_SIZE);

  const { rows, loading, loadingMore, hasMore, error } = useMeasurementResults(
    db,
    uid,
    {
      collectionName: CONFIG.collectionName,
      pageSize,
      orderField: "createdAt",
    },
  );

  const { handleScroll } = useInfiniteResultsPageSize({
    canLoadMore: hasMore,
    loading,
    loadingMore,
    rowsLength: rows.length,
    resetKey: `${uid || ""}:${CONFIG.resetKey}`,
    pageSize,
    setPageSize,
    initialPageSize: DEFAULT_RESULTS_PAGE_SIZE,
  });

  const onRowClick = useResultRowNavigation({
    variant: CONFIG.variant,
    context: CONFIG.context,
  });

  return (
    <ResultsTabState
      uid={uid}
      loading={loading}
      error={error}
      rows={rows}
      emptyMode={CONFIG.mode}
      firstRunByVariant={firstRunByVariant}
    >
      <div
        aria-label="manual audio results list"
        className="w-full h-full min-h-0 overflow-y-auto"
        onScroll={handleScroll}
      >
        {rows.map((row, idx) => (
          <ManualAudioResultRow
            key={row.id ?? idx}
            time={row.time}
            date={row.date}
            uploadFailed={row.uploadFailed}
            manualAudioComplete={row.manualAudioComplete}
            onClick={() => onRowClick(row)}
          />
        ))}
        {loadingMore ? <Spinner size={24} className="py-4" /> : null}
      </div>
    </ResultsTabState>
  );
});
